import { useMutation } from "@tanstack/react-query";
import { api } from "../../libs/axios";

export function useMutationDinheiro() {
  return useMutation({
     mutationFn: async ({id, senha}: {id: string, senha: string}) => {
      const response = await api.post(`/checkout/dinheiro`, {
        id,
        senha
      });

      return response.data;
    },
  });
}